export const HEADER_MOBILE_HEIGHT = 56;
export const CLASS_REACT_MODAL_OPEN = 'ReactModal__Body--open';
